export class MockPoleService {
  getAllPoles = jasmine.createSpy('getAllPoles');
}
